import styled from 'styled-components';
import { rem } from 'polished';
import Config from '@config';
import Button from '@atoms/Button/Button';
import Text from '@atoms/Text/Text';

export const StyledCheckoutPaymentButtonWrapper = styled.div`
  width: 100%;
  margin-bottom: ${rem(24)};
`;

export const StyledCheckoutSubmitButton = styled(Button)`
  width: 100%;
  margin-top: ${rem(24)};
  margin-left: auto;
  margin-right: auto;

  ${Config.MEDIA.FROM_TABLET_PORTRAIT} {
    margin-top: ${rem(40)};
    width: ${rem(186)};
  }
`;

export const StyledText = styled(Text)`
  margin-top: ${rem(12)};

  ${Config.MEDIA.FROM_TABLET_PORTRAIT} {
    margin-top: ${rem(16)};
  }

  text-align: center;
`;

export const StyledSwedbankPayLogo = styled.img`
  display: block;
  margin: ${rem(12)} auto;
  width: ${rem(24)};
  height: auto;
`;

export const StyledErrorModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(20)};
`;

export const StyledSupportText = styled(Text)`
  ${Config.MEDIA.FROM_TABLET_PORTRAIT} {
    margin-bottom: ${rem(20)};
  }
`;
